export default __webpack_public_path__ + "static/placeholder-255a09dec4d9fcf60968cbf073140722.png";